import { ErrorBanner } from 'ui/banner';
import { useConditionalContentErrorMessage } from '../hooks/form/errors/useConditionalContentErrorMessage';

export const DATA_TEST = 'conditional-content-error';

export const ConditionalContentError = () => {
  const errorMessage = useConditionalContentErrorMessage();

  return <ErrorBanner data-test={DATA_TEST}>{errorMessage}</ErrorBanner>;
};
